import * as React from "react";

import {
  BANNER,
  PRODUCT_CARDS,
  SCR_FOOTER,
} from "./mock/SignupConfirmationConstants";
import { Connector } from "./signupConfirmationResponsiveConnector";
import { getCurrentEnv } from "@sfly/uig-current-environment-util";
import "./scss/signupConfirmationResponsive.scss";
import SFLYAuth from "../common/util/SFLYAuth";
import Spinner from '@sfly/uig-spinner';
import Logger from "../common/util/Logger";
import { OmnitureUtil } from "../common/util/OmnitureUtil";

const env = getCurrentEnv() === "production" ? "" : `.${getCurrentEnv()}`;
const loggerInstance = new Logger('SignupConfirmationResponsive', 'NEW-SIGNUPCONFIRMATION-PAGE');
class SignupConfirmationResponsive extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      isLoadedisDelayedPageLoadTriggered: false,
      banner: BANNER,
      productCards: PRODUCT_CARDS,
      footerContent: SCR_FOOTER
    };
    this.connector = new Connector(props.dispatch);
    this.updateProductCardsAttributes = this.updateProductCardsAttributes.bind(
      this
    );
    this.renderSignupConfirmationContent = this.renderSignupConfirmationContent.bind(this);
  }

  triggerAnalyticsEvents() {
    OmnitureUtil.trackPageLoad('/signupconfirmation', 'account pages');
    if (
        window.SFLY_DTL &&
        window.SFLY_DTL.session &&
        window.SFLY_DTL.session.visitorDetails.visitorType === 'signedIn' &&
        window.SFLY_DTL.session.visitorDetails.customerId &&
        typeof window._satellite !== 'undefined'
    ) {
        window._satellite.pageBottom();
        window._satellite.track('delayed_page_load');
        this.setState({
            isDelayedPageLoadTriggered: true,
        });
    }
}

  // First Check if User is Autheniticated or not, If not First Authenicate then Fetch dc's and bind data to state.
  componentDidMount() {
    SFLYAuth.authenticate().then(response => {
      const { type, error } = response;
      if (type === 'AUTHENTICATION_SUCCESS') {
        this.setState({
          isAuthenticated:true,
        });
        this.renderSignupConfirmationContent();
        if (window.signupConfirmationStartTime) {
          const loadTime =
            new Date().getTime() - window.signupConfirmationStartTime;
          if (!Number.isNaN(loadTime)) {
            loggerInstance.metricDuration('NEW-SIGNUPCONFIRMATION-PAGE-LOADTIME', loadTime);
          }
        }
      } else {
        SFLYAuth.redirectToSignUp(error);
      }
  });
  }

  renderSignupConfirmationContent() {
    this.updateProductCardsAttributes();
    window.addEventListener("resize", this.updateProductCardsAttributes);
    this.connector.fetchAllDCs().then(
      response => {
        if (response &&
          response.dynamicContents &&
          response.dynamicContents.length > 0) {
          const parsedResult = this.connector.parseDcResponse(
            response.dynamicContents
          );
          if (parsedResult) {
            this.setState({
              banner: parsedResult.banner || this.state.banner,
              productCards: parsedResult.productCards || this.state.productCards,
              footerContent: parsedResult.footerContent || this.state.footerContent
            });
          }
        }
      },
      error => {
        this.connector.errorLogger(
          "Failed to retrieve signup confirmation dcs data from endpoint. Using fallback config.",
          error
        );
      }
    );
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateProductCardsAttributes);
  }

  // Update Product card row index
  updateProductCardsAttributes() {
    const screenWidth = window.innerWidth;
    const productCardsDiv = document.getElementById("productCards");
    const aTags = productCardsDiv.getElementsByTagName("a");
    let cardPerRow = 3;

    if (screenWidth < 992 && screenWidth >= 768) {
      cardPerRow = 2;
    } else if (screenWidth < 768) {
      cardPerRow = 1;
    }

    for (let i = 0, k = 0, p = 0; i < aTags.length; i++) {
      if (i % cardPerRow === 0) {
        k++;
        p = 1;
      } else {
        p++;
      }
      aTags[i].setAttribute("data-link-module-position", `Row ${k}`);
      aTags[i].setAttribute("data-link-position", p);
      aTags[i].setAttribute("tabIndex", i + 2);
    }
  }

  renderBanner() {
    const photosUrl = `https://photos${env}.shutterfly.com/add`;
    return (
      <div className="scp_banner">
            <picture>
              <img
                    src={this.state.banner.imageUrl}
                    alt="Banner image"
                />
        </picture>
            <div className="welcome_msg_box_wrapper">
            <div className="welcome_msg_box">
              <h1>{this.state.banner.heading}</h1>
              <h2>{this.state.banner.subHeading}</h2>
              <span>{this.state.banner.note}</span>
            <a href={ photosUrl }
                      className="uig-button uig-primary-button"
                      tabIndex="1"
              data-link-id="Upload Photos"
                      data-link-module="Top Banner"
                      data-link-module-type="upload-photo-nav"
                      data-link-module-position="Row 1"
              data-link-position="1"
                  >
                      {this.state.banner.buttonText}
                  </a>
          </div>
        </div>
        </div>
    );
  }

  renderProducts() {
    const productCards = [],
      products = this.state.productCards.products;

    // Create product cards
    for (let i = 0; i < products.length; i++) {
      const productId = products[i].heding.replace(" ", "_");
      productCards.push(
        <div id={productId} key={`product_${i}`} className="product_card">
              <img
                key={`product_img_${i}`}
                src={products[i].imageUrl}
                alt={products[i].imageAltText}
            />
          <div key={`product_cb_${i}`} className="content-block">
            <h3>{products[i].heding}</h3>
                <p>{products[i].description}</p>
                <a
                  href={products[i].linkUrl}
                  data-link-id={products[i].heding}
                  data-link-module="Shop Now"
              data-link-module-type="product-nav"
              >
              {products[i].linkText}
            </a>
            </div>
          </div>
      );
    }

    return <div className="product_card_wrapper">{productCards}</div>;
  }

  renderFooter() {
    if (!this.state.footerContent) {
      return null;
    }

    return (
      <div className="footer_wrapper">
        <h2>{this.state.footerContent.heding}</h2>
            <h4>{this.state.footerContent.subHeading}</h4>
            <div className="scf_link_block">
              <div className="image_block">
            <img
                      src={this.state.footerContent.desktop.imageUrl}
                      alt={this.state.footerContent.desktop.imageAltText}
                  />
          </div>
          <h2>{this.state.footerContent.desktop.heding}</h2>
              <h5>{this.state.footerContent.desktop.subHeading}</h5>
          </div>
        <div className="scf_link_block">
          <div className="image_block">
                <img
                      src={this.state.footerContent.mobile.imageUrl}
                      alt={this.state.footerContent.mobile.imageAltText}
                  />
            </div>
              <h2>{this.state.footerContent.mobile.heding}</h2>
          <h5>{this.state.footerContent.mobile.subHeading}</h5>
          </div>
        </div>
    );
  }

  renderDisclaimer() {
    if (!this.state.footerContent.disclaimer) {
      return null;
    }

    return (
        <p className="sc_disclaimer">{this.state.footerContent.disclaimer}</p>
    );
  }

  render() {
    const { isAuthenticated, isDelayedPageLoadTriggered } = this.state;
    if (!isDelayedPageLoadTriggered) {
      this.triggerAnalyticsEvents();
    }
    return (
      <>
      { isAuthenticated ? 
      <div className="signup_confirmation">
            {this.renderBanner()}

        <div className="product_list_header">
              <h2 className="mp_0">{this.state.productCards.heading}</h2>
          <h4 className="mp_0">{this.state.productCards.subHeading}</h4>
          </div>
        <div id="productCards" className="product_card_list">
              {this.renderProducts()}
          </div>
        <div className="clear_both" />
            {this.renderFooter()}
            <hr />
        {this.renderDisclaimer()}
      </div> : <Spinner isLabelVisible={true} size={'xl'} labelPosition={'bottom'} />  }
        </>
    );
  }
}

export default SignupConfirmationResponsive;
